<template>
    <div style="overflow-x:hidden">
        <!-- <BannerStatic :ban="banner" ></BannerStatic> -->
        
        <Medical :bg="background" class="px-360" style="margin-top: 80px;"></Medical>
    </div>
</template>

<script>
import BannerStatic from '@/components/header/bannerStatic.vue'
import Medical from '@/components/medical/medical.vue'

export default {
    components:{
        BannerStatic,
        Medical
    },
    data(){
        return{
            banner: require('@/assets/logo1.2.png'),
            background: require('@/assets/bgHonor.png')
        }
    }
    
}
</script>